import { Box, Button, Divider, Modal, Typography } from '@mui/material';
import { AwardIcon } from '../../AwardIcon';
import { useState } from 'react';
import { useAuth } from '../../../utils/AuthContext';
import { deleteAward } from '../../../utils/API';

const AwardModal = ({ open, handleClose, pid, award }) => {
  const { user } = useAuth();

  const isAdmin = user?.role === 'ADMIN';

  const deleteA = async (id) => {
    try {
      await deleteAward(pid, id);
      handleClose();
      // reload after 3 seconds
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error('Error deleting award:', error);
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    maxWidth: 500,
    width: '90%',
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="award-modal-title"
      aria-describedby="award-modal-description"
    >
      <Box sx={style}>
        <Box display="flex" alignItems="center" mb={2} gap={1}>
          <AwardIcon icon={award?.icon} />

          <Typography id="award-modal-title" variant="h6" component="h2">
            {award?.title}
          </Typography>
        </Box>
        <Divider />
        <Typography id="award-modal-description" sx={{ mt: 2 }}>
          {award?.description}
        </Typography>

        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Year: {award?.year || 'N/A'}
          </Typography>
        </Box>

        {isAdmin && (
          <>
            <Divider sx={{ mt: 2 }} />
            <Button
              variant="contained"
              color="error"
              sx={{ mt: 2 }}
              fullWidth
              onClick={() => deleteA(award?._id)}
            >
              Delete Award
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

const InformAwards = ({ project }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [selectedAward, setSelectedAward] = useState(null);
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="row" gap={1}>
        {project?.awards?.length > 0 ? (
          project.awards.map((award) => (
            <Box
              key={award._id}
              display="flex"
              alignItems="center"
              gap={1}
              onClick={() => {
                setSelectedAward(award);
                setOpen(true);
              }}
              sx={{ cursor: 'pointer' }}
            >
              <AwardIcon icon={award.icon} />
            </Box>
          ))
        ) : (
          <></>
        )}
      </Box>
      {project && (
        <AwardModal
          open={open}
          handleClose={() => setOpen(false)}
          pid={project._id}
          award={selectedAward}
        />
      )}
    </Box>
  );
};

export default InformAwards;
